<template>
  <v-card class="pa-0 rounded-0" :width="`100%`" :height="325" fluid grid-list-md>
   <h3 class="grey--text text--darken-1 ml-2 mt-2"> {{$tc('title.grafico_lojas_segmentadas_akzo')}} </h3>
     <v-container v-if="!isDadosGrafico"  class="Dash__sem_dados" >
        <p class="grey--text text--darken-1"> {{$tc('label.tabela_sem_conteudo', 1)}} </p>
     </v-container>
   <grafico-barras-segmentacao
        v-if="isDadosGrafico"
        :category-field="`divisao`"
        :value-fields="valueFields"
        :dados="dados"
        :info-y-axis="`${(this.$t('label.quantidade'))}`"
        :tipo-barra-ranking="true"
         />
    </v-card>
</template>
<script>

import GraficoBarrasSegmentacao from './graficos/GraficoBarrasSegmentacao';
import { buscarDashboardLojasSegmentadas } from '../../../../common/resources/akzo-dashboard-segmentacao';

export default {
  name: 'DashboardGraficoLojasSegmentadas',
  props: {
    filtros: {
      type: Object,
    },
  },
  components: {
    GraficoBarrasSegmentacao,
  },
  data() {
    return {
      dashboardSegmentacaoResource: this.$api.akzoDashboardSegmentacao(this.$resource),
      filtrosAplicados: this.filtros,
      dados: [],
      valueFields: [],
    };
  },
  watch: {
    filtros: {
      handler() {
        this.filtrosAplicados = this.filtros;
        this.buscarDados();
      },
    },
  },
  computed: {
    isDadosGrafico() {
      return this.dados && this.dados.length > 0;
    },
  },
  methods: {

    buscarDados() {
      buscarDashboardLojasSegmentadas(this.filtros, this.$resource)
        .then((response) => {
          this.dados = response.data.dados;
          this.valueFields = [{
            balloonText: `${this.$t('label.quantidade')}: [[value]]`,
            showAllValueLabels: true,
            fillAlphas: 0.8,
            lineAlpha: 0.2,
            title: this.$t('label.quantidade'),
            type: 'column',
            valueField: 'valor',
          }];
        }).catch((err) => {
          this.$error(this, err);
        });
    },
  },
};
</script>

<style>
   .Dash__sem_dados{
     display: flex;
     height: 200px!important;
     width: 100%;
     align-items: center;
     justify-content: center;
   }
</style>
